<template>
  <div class="pro-inside" v-loading="loading">
    <div class="crumbs">
      <p>
        <a href="/home" target="">首页</a> /
        <a @click="handleThirdClick(parentId)" target="">{{parentName}}</a> /
        <a href="" target="">{{title}}</a>
      </p>
    </div>
    <div class="container">
      <div class="detail-row">
        <div class="detail-slide">
          <el-carousel
              height="100%"
              indicator-position="bottom"
              arrow="hover"
              class="product-carousel"
          >
            <el-carousel-item v-for="(item, idx) in productList" :key="idx">
              <img :src="item.url" :alt="item.name" class="carousel-img" />
            </el-carousel-item>
          </el-carousel>
        </div>

        <div class="detail-list">
          <h2 class="nowrap">{{ title }}</h2>
          <p v-if="portal">品牌：{{ portal }}</p>
          <p v-if="color">颜色：{{ color }}</p>
          <p v-if="texture">材质：{{ texture }}</p>
          <p v-if="weight">重量：{{ weight }}</p>
          <p v-if="structure" class="b-size">结构：{{ structure }}</p>
          <p v-if="model" class="b-size">型号：{{ model }}</p>

          <div class="shop-buy-wrapper">
            <span class="buy-tip">前往商城购买<i class="fa fa-long-arrow-right"></i></span>
            <div class="shop-list-container">
              <a
                  v-for="(item, ids) in shopList"
                  :key="ids"
                  :href="item.url"
                  target="_blank"
                  class="shop-item"
              >
                <img class="shop-logo" :src="item.src" :alt="item.title"/>
                <span class="shop-title">{{ item.title }}</span>
              </a>
            </div>
          </div>

          <p>更多产品详情，敬请莅临 <em>璟店门店</em></p>
        </div>
      </div>

      <!-- 富文本区域：结构不变 -->
      <div class="art-body">
        <div class="rich-text-content" v-html="content"></div>
      </div>
    </div>
  </div>
</template>

<script>
// script 部分完全不变，此处省略（和上一版一致）
import { getImgList, getPortalCategoryDetailVoById } from "@/api/home";
import { ImageTypeEnum } from "@/enums/imageTypeEnum";

export default {
  data() {
    return {
      productList: [],
      shopList: [],
      title: '',
      portal: '',
      color: '',
      texture: '',
      weight: '',
      structure: '',
      model: '',
      content: "",
      productId: '',
      loading: false,
      parentId:'',
      parentName:'',
    };
  },
  watch: {
    "$route.query": {
      immediate: true,
      handler(newQuery) {
        const { productId,parentId, parentName } = newQuery;
        if(parentId){
          this.parentId = parentId;
        }
        if(parentName){
          this.parentName = parentName;
        }
        if (productId) {
          this.productId = productId;
          this.getProductDetailById(productId);
        } else {
          this.$message?.warning("产品ID不能为空");
        }
      },
    },
  },
  created() {
    this.getBannerList();
  },
  methods: {
    handleThirdClick(parentId){
      const parts = parentId.split('-');
      const child = parts[1];
      const parent = parts[0];
      this.$router.push({
        path: "/third_cl",
        query: {
          parentId: parent,
          childrenId: child
        }
      });
    },
    async getProductDetailById(productId) {
      try {
        this.loading = true;
        const res = await getPortalCategoryDetailVoById(productId);
        if (res.code === 200 && res.data?.length) {
          const data = res.data[0];
          if (data.photos && Array.isArray(data.photos)) {
            this.productList = data.photos.map(item => ({
              ...item,
              url: data.url ? `${data.url}${item.url}` : item.url
            }));
          }
          this.title = data.name || '';
          this.portal = data.portal || '';
          this.color = data.color || '';
          this.texture = data.texture || '';
          this.weight = data.weight || '';
          this.structure = data.structure || '';
          this.model = data.model || '';
          this.content = data.content;
        } else {
          this.$message.error(res.msg || "获取产品详情失败");
        }
      } catch (error) {
        console.error("产品详情请求失败：", error);
        this.$message.error("网络异常，请稍后重试");
      } finally {
        this.loading = false;
      }
    },
    async getBannerList() {
      try {
        const res = await getImgList(ImageTypeEnum.SHOP_HOME_LIST.value);
        this.shopList = res.data || [];
      } catch (error) {
        console.error("获取商城列表失败：", error);
        this.shopList = [];
      }
    },
  }
};
</script>

<style scoped lang="scss">
// 全局重置、面包屑、容器、轮播、信息区、商城购买区的样式完全不变，此处省略（和上一版一致）
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.pro-inside {
  background: url('../../../assets/img/product/gray_bg.jpg') 0 0 no-repeat;
  background-size: cover;
  background-attachment: fixed;
  margin-top: 100px;
  min-height: 100vh;
  overflow-x: hidden;

  @media (max-width: 768px) {
    margin-top: 60px;
    background-position: center;
  }
}

.crumbs {
  padding: 20px 40px;
  background: rgba(255, 255, 255, .9);
  width: 100%;
  position: relative;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    padding: 10px 15px;
    margin-bottom: 10px;
  }

  p {
    color: #999;
    font-size: 12px;
    line-height: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    @media (max-width: 768px) {
      font-size: 11px;
      line-height: 18px;
    }
  }

  p a {
    display: inline-block;
    vertical-align: top;
    margin: 0 8px;
    color: #666;
    text-decoration: none;

    @media (max-width: 768px) {
      margin: 0 4px;
    }
  }

  p a:first-child {
    margin-left: 0;
  }

  p a:hover {
    color: #000;
  }

  h2 {
    font-size: 30px;
    color: #555;

    @media (max-width: 768px) {
      font-size: 20px;
    }
  }
}

.container {
  position: relative;
  max-width: 1600px;
  margin: 0 auto;
  padding: 0 20px;
  width: 100%;
  overflow-x: hidden;
}

.detail-row {
  display: flex;
  align-items: flex-start;
  width: 100%;
  gap: 20px;
  flex-wrap: nowrap;
  margin-bottom: 40px;

  @media (max-width: 768px) {
    flex-wrap: wrap;
    gap: 15px;
    margin-bottom: 20px;
  }
}

.detail-slide {
  width: calc(50% - 10px);
  animation: leftIn 0.8s 0.15s both;
  position: relative;
  padding-top: 50%;
  height: 0;

  @media (max-width: 768px) {
    width: 100%;
    padding-top: 75%;
    height: 300px;
  }

  .product-carousel {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
}

.carousel-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  margin: 0 auto;
}

.detail-list {
  width: calc(50% - 10px);
  padding: 15px 30px;
  animation: rightIn 0.8s 0.15s both;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 300px;
  background: rgba(255, 255, 255, 0.85);
  border-radius: 8px;

  @media (max-width: 768px) {
    width: 100%;
    padding: 10px 15px;
    min-height: auto;
    justify-content: flex-start;
    border-radius: 4px;
  }

  h2 {
    margin-bottom: 20px;
    font-size: 28px;
    color: #000;
    margin-top: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    @media (max-width: 768px) {
      font-size: 18px;
      margin-bottom: 15px;
    }
  }

  p {
    color: #666;
    line-height: 34px;
    margin: 8px 0;
    font-size: 16px;

    @media (max-width: 768px) {
      font-size: 14px;
      line-height: 28px;
      margin: 6px 0;
    }

    em {
      color: #d26b6b;
      font-style: normal;
    }
  }

  .b-size {
    height: 60px;
    line-height: 60px;
    border-top: 1px solid rgba(107, 110, 117, 0.2);
    margin: 0;

    @media (max-width: 768px) {
      height: 40px;
      line-height: 40px;
    }
  }
}

.shop-buy-wrapper {
  padding: 10px 0;
  border-top: 1px solid rgba(107, 110, 117, 0.2);
  margin-top: 10px;
  display: flex;
  flex-wrap: nowrap;
  min-height: 42px;

  @media (max-width: 768px) {
    flex-wrap: wrap;
    padding: 8px 0;
    margin-top: 8px;
    min-height: auto;
  }
}

.buy-tip {
  display: inline-flex;
  align-items: center;
  height: 42px;
  padding: 0 10px;
  line-height: 42px;
  background: #d55c5c;
  font-size: 16px;
  color: #fff;
  border-radius: 3px;
  cursor: pointer;
  white-space: nowrap;
  flex: 0 0 auto;
  margin-right: 10px;

  @media (max-width: 768px) {
    width: 100%;
    margin-right: 0;
    margin-bottom: 10px;
    justify-content: center;
    height: 38px;
    line-height: 38px;
    font-size: 14px;
  }

  i {
    margin-left: 6px;
    font-size: 18px;
    color: #fff;

    @media (max-width: 768px) {
      font-size: 16px;
      margin-left: 4px;
    }
  }
}

.shop-list-container {
  flex: 1 1 auto;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;

  @media (max-width: 768px) {
    width: 100%;
    justify-content: flex-start;
    gap: 8px;
  }
}

.shop-item {
  display: inline-flex;
  align-items: center;
  height: 36px;
  padding: 0 10px;
  line-height: 36px;
  border-radius: 3px;
  color: #666;
  text-decoration: none;
  white-space: nowrap;
  transition: background 0.3s;

  @media (max-width: 768px) {
    height: 32px;
    line-height: 32px;
    padding: 0 8px;
  }

  &:hover {
    background: #eee;
    color: #d55c5c;
  }

  .shop-logo {
    width: 16px;
    height: 16px;
    margin-right: 6px;
    display: inline-block;
    vertical-align: middle;

    @media (max-width: 768px) {
      width: 14px;
      height: 14px;
      margin-right: 4px;
    }
  }

  .shop-title {
    font-size: 14px;

    @media (max-width: 768px) {
      font-size: 12px;
    }
  }
}

// ========== 核心修改：富文本样式，解决移动端超宽 ==========
.art-body {
  padding: 20px;
  box-sizing: border-box;
  text-align: center;
  //background: rgba(255, 255, 255, 0.85);
  border-radius: 8px;
  margin-bottom: 40px;
  width: 100%;
  overflow-x: hidden; // 关键：隐藏横向溢出

  // PC端：正常样式，不做额外限制
  @media (min-width: 769px) {
    .rich-text-content {
      max-width: 1200px; // PC端最大宽度，可选
      margin: 0 auto;
    }
  }

  // 移动端：强制限制，彻底解决超宽
  @media (max-width: 768px) {
    border-radius: 4px;
    margin-bottom: 20px;
    width: 100vw; // 强制视口宽度
    margin-left: calc(50% - 50vw); // 居中，抵消容器内边距

    // 移动端富文本容器：视口级限制
    .rich-text-content {
      max-width: calc(100vw - 30px) !important; // 关键：视口宽度 - 左右内边距，绝对不超宽
      width: 100% !important;
      margin: 0 auto !important;
      overflow-x: hidden !important;
    }
  }

  // 富文本内容容器
  .rich-text-content {
    width: 100%;
    max-width: 100%;
    margin: 0 auto;
    overflow-x: hidden;
  }

  // ========== 核心：深度选择器，穿透scoped，强制覆盖富文本内的图片 ==========
  // PC端：正常显示，宽度100%，不超容器
  ::v-deep .rich-text-content img {
    display: block !important;
    width: 100% !important;
    max-width: 100% !important;
    height: auto !important;
    margin: 0 auto 15px auto !important;
    padding: 0 !important;
    border: none !important;
    object-fit: contain !important;
  }

  // 移动端：单独加强，视口级限制，绝对不超宽
  @media (max-width: 768px) {
    ::v-deep .rich-text-content img {
      max-width: calc(100vw - 30px) !important; // 关键：视口宽度 - 左右15px内边距
      width: 100% !important;
      height: auto !important;
      object-fit: contain !important;
    }
  }

  // 深度选择器：富文本内的段落，强制换行，防止超宽
  ::v-deep .rich-text-content p {
    margin-bottom: 20px !important;
    font-size: 16px !important;
    color: #666 !important;
    text-align: justify !important;
    line-height: 30px !important;
    width: 100% !important;
    word-wrap: break-word !important;
    word-break: break-all !important;

    @media (max-width: 768px) {
      font-size: 14px !important;
      line-height: 26px !important;
      margin-bottom: 15px !important;
      max-width: calc(100vw - 30px) !important; // 段落也不超宽
    }
  }

  // 兼容旧样式
  img {
    display: block;
    margin: 0 auto;
    max-width: 100% !important;
    width: 100% !important;
    height: auto !important;
    border-radius: 4px;
  }

  p {
    margin-bottom: 20px;
    font-size: 16px;
    color: #666;
    text-align: justify;
    line-height: 30px;

    @media (max-width: 768px) {
      font-size: 14px;
      line-height: 26px;
      margin-bottom: 15px;
    }
  }
}

// 动画样式不变
@keyframes leftIn {
  from {
    opacity: 0;
    transform: translateX(-50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@-webkit-keyframes leftIn {
  from {
    opacity: 0;
    -webkit-transform: translateX(-50px);
  }
  to {
    opacity: 1;
    -webkit-transform: translateX(0);
  }
}

@keyframes rightIn {
  from {
    opacity: 0;
    transform: translateX(50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@-webkit-keyframes rightIn {
  from {
    opacity: 0;
    -webkit-transform: translateX(50px);
  }
  to {
    opacity: 1;
    -webkit-transform: translateX(0);
  }
}
</style>